import React, { useState, useEffect } from 'react';
import {
  Create,
  Visibility,
  Work,
  Done,
  PendingActions,
  TrendingUp,
  TrendingDown,
  AttachMoney,
  Person,
  Assignment,
  CheckCircle,
  Error,
  Warning,
  Info,
  CalendarToday,
  AccessTime,
  Star,
  StarBorder,
     Refresh,
   Download,
   Upload,
   Add,
   Remove,
  Schedule,
  TrendingFlat,
  Speed,
  Assessment,
  BarChart,
  PieChart,
  Timeline,
     Settings,
   Help,
  Dashboard as DashboardIcon,
  PlayArrow,
  Stop,
  Check,
  Close,
  Edit,
  Delete,
  GetApp,
  CloudUpload,
  Description,
  Image,
  VideoLibrary,
  Folder,
  Archive,
  Unarchive,
  Flag,
  PriorityHigh,
  LowPriority,
  AccessTimeFilled,
  Timer,
  TimerOff,
  NotificationsActive,
  NotificationsOff,
  VisibilityOff,
  VisibilityOn,
  MoreVert,
  ExpandMore,
  ExpandLess,
  KeyboardArrowRight,
  KeyboardArrowLeft,
  FirstPage,
  LastPage,
  NavigateNext,
  NavigateBefore,
  Link,
  Business
} from '@mui/icons-material';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-hot-toast';
import { designerDesignCaseApi } from '../../services/designer/designCaseApi';
import { useAuth } from '../../contexts/AuthContext';

const DesignerCaseList = () => {
  const { user } = useAuth();
  const [cases, setCases] = useState([]);
  const [availableCases, setAvailableCases] = useState([]);
  const [loading, setLoading] = useState(true);
     const [filterTab, setFilterTab] = useState(0);
  const [selectedCase, setSelectedCase] = useState(null);
  const [showDetailDialog, setShowDetailDialog] = useState(false);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [uploadingFiles, setUploadingFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showAvailableCases, setShowAvailableCases] = useState(false);
  const [uploadUrls, setUploadUrls] = useState(['']);
  const [uploadTab, setUploadTab] = useState('url'); // 'file' or 'url'
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedImageAlt, setSelectedImageAlt] = useState('');
  const [imageScale, setImageScale] = useState(1);
  const [showAvailableCaseDetail, setShowAvailableCaseDetail] = useState(false);
  const [selectedAvailableCase, setSelectedAvailableCase] = useState(null);

  useEffect(() => {
    fetchCases();
  }, []);

  const fetchCases = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem('token');
      
      if (!token) {
        toast.error('Vui lòng đăng nhập lại');
        return;
      }

      // Fetch my cases
       const myCasesResponse = await designerDesignCaseApi.getMyCases(token);
      setCases(myCasesResponse.data || []);

      // Fetch available cases
      const availableResponse = await designerDesignCaseApi.getAvailableCases(token);
      console.log(`availableResponse: ${availableResponse.data}`);
      const availableData = availableResponse.data || [];
      // Lọc bỏ cases cancelled khỏi available cases
      const filteredAvailable = availableData.filter(case_ => case_.status !== 'cancelled');
      setAvailableCases(filteredAvailable);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching cases:', error);
      toast.error('Không thể tải danh sách cases');
      setLoading(false);
    }
  };

  const handleAssignCase = async (caseId) => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        toast.error('Vui lòng đăng nhập lại');
        return;
      }

      await designerDesignCaseApi.assignCase(token, caseId);
      toast.success('Đã nhận case thành công!');
      fetchCases();
    } catch (error) {
      console.error('Error assigning case:', error);
      toast.error('Có lỗi xảy ra khi nhận case');
    }
  };


  const getStatusColor = (status) => {
    switch (status) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'in_progress':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'waiting_approval':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'approved':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'rejected':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'cancelled':
        return 'bg-gray-100 text-gray-800 border-gray-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return <PendingActions className="w-4 h-4" />;
      case 'in_progress':
        return <Work className="w-4 h-4" />;
      case 'waiting_approval':
        return <Info className="w-4 h-4" />;
      case 'approved':
        return <CheckCircle className="w-4 h-4" />;
      case 'rejected':
        return <Error className="w-4 h-4" />;
      case 'cancelled':
        return <Close className="w-4 h-4" />;
      default:
        return <Assignment className="w-4 h-4" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return 'Chờ nhận';
      case 'in_progress':
        return 'Đang làm';
      case 'waiting_approval':
        return 'Chờ duyệt';
      case 'approved':
        return 'Hoàn thành';
      case 'rejected':
        return 'Từ chối';
      case 'cancelled':
        return 'Đã hủy';
      default:
        return 'Không xác định';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'bg-red-100 text-red-800 border-red-200';
      case 'medium':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'low':
        return 'bg-green-100 text-green-800 border-green-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND'
    }).format(amount);
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString('vi-VN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('vi-VN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const formatProductName = (productName) => {
    if (!productName) return 'Sản phẩm không xác định';
    
    // Tìm vị trí của "- SKU:" và cắt bỏ phần đó
    const skuIndex = productName.indexOf('- SKU:');
    if (skuIndex !== -1) {
      return productName.substring(0, skuIndex).trim();
    }
    
    return productName;
  };

  const handleViewCase = (case_) => {
    setSelectedCase(case_);
    setShowDetailDialog(true);
  };

  const handleImageClick = (imageUrl, altText) => {
    setSelectedImage(imageUrl);
    setSelectedImageAlt(altText);
    setImageScale(1);
    setShowImagePopup(true);
  };

  const handleViewAvailableCase = (case_) => {
    setSelectedAvailableCase(case_);
    setShowAvailableCaseDetail(true);
  };

  const handleImageWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.1 : 0.1;
    const newScale = Math.max(0.5, Math.min(3, imageScale + delta));
    setImageScale(newScale);
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      // Giới hạn tối đa 5 files
      if (files.length > 5) {
        toast.error('Chỉ được upload tối đa 5 ảnh!');
        return;
      }
      setUploadingFiles(files);
    }
  };

  const handleUrlChange = (index, value) => {
    const newUrls = [...uploadUrls];
    newUrls[index] = value;
    setUploadUrls(newUrls);
  };

  const addUrlField = () => {
    if (uploadUrls.length < 5) {
      setUploadUrls([...uploadUrls, '']);
    } else {
      toast.error('Chỉ được upload tối đa 5 URLs!');
    }
  };

  const removeUrlField = (index) => {
    if (uploadUrls.length > 1) {
      const newUrls = uploadUrls.filter((_, i) => i !== index);
      setUploadUrls(newUrls);
    }
  };

  const handleUploadDesign = async (caseId, files) => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        toast.error('Vui lòng đăng nhập lại');
        return;
      }

      setUploadProgress(0);

      // Simulate upload progress
      const progressInterval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 200);

      // Upload multiple files
      for (let i = 0; i < files.length; i++) {
        await designerDesignCaseApi.uploadDesignFile(token, caseId, files[i]);
      }
      
      clearInterval(progressInterval);
      setUploadProgress(100);
      
      setTimeout(() => {
        toast.success(`Upload ${files.length} design thành công!`);
        setShowUploadDialog(false);
        setUploadingFiles([]);
        setUploadProgress(0);
        fetchCases();
      }, 500);

    } catch (error) {
      console.error('Error uploading design:', error);
      toast.error('Có lỗi xảy ra khi upload design');
      setUploadingFiles([]);
      setUploadProgress(0);
    }
  };

  const handleUploadUrls = async (caseId, urls) => {
    try {
      const token = sessionStorage.getItem('token');
      if (!token) {
        toast.error('Vui lòng đăng nhập lại');
        return;
      }

      // Filter out empty URLs
      const validUrls = urls.filter(url => url.trim() !== '');
      if (validUrls.length === 0) {
        toast.error('Vui lòng nhập ít nhất 1 URL!');
        return;
      }

      setUploadProgress(0);

      // Simulate upload progress
      const progressInterval = setInterval(() => {
        setUploadProgress(prev => {
          if (prev >= 90) {
            clearInterval(progressInterval);
            return 90;
          }
          return prev + 10;
        });
      }, 200);

      // Call the actual API - send array of URLs
      await designerDesignCaseApi.uploadUrlDesignFile(token, caseId, validUrls);
      
      clearInterval(progressInterval);
      setUploadProgress(100);
      
      setTimeout(() => {
        toast.success(`Upload ${validUrls.length} URLs thành công!`);
        setShowUploadDialog(false);
        setUploadUrls(['']);
        setUploadProgress(0);
        fetchCases();
      }, 500);

    } catch (error) {
      console.error('Error uploading URLs:', error);
      toast.error('Có lỗi xảy ra khi upload URLs');
      setUploadProgress(0);
    }
  };

     const filteredCases = cases.filter(case_ => {
     // Ẩn cases cancelled khỏi danh sách designer
     if (case_.status === 'cancelled') {
       return false;
     }
     
     const matchesTab = filterTab === 0 || 
                       (filterTab === 1 && case_.status === 'in_progress') ||
                       (filterTab === 2 && case_.status === 'waiting_approval') ||
                       (filterTab === 3 && case_.status === 'approved') ||
                       (filterTab === 4 && case_.status === 'rejected');
     return matchesTab;
   });

  const tabLabels = ['Tất cả', 'Đang làm', 'Chờ duyệt', 'Hoàn thành', 'Từ chối'];

  if (loading) {
    return (
      <div className="w-full mt-8">
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 h-2 rounded-full animate-pulse"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto"
      >


                 {/* Stats Cards */}
         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
           <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.1 }}
             whileHover={{ scale: 1.05 }}
             className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-6 text-white shadow-xl"
           >
             <div className="flex items-center justify-between">
               <div>
                 <p className="text-blue-100 text-sm font-medium">Cases của tôi</p>
                 <p className="text-3xl font-bold">{cases.length}</p>
               </div>
               <Assignment className="text-4xl text-blue-200" />
             </div>
           </motion.div>

           <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.2 }}
             whileHover={{ scale: 1.05 }}
             className="bg-gradient-to-br from-yellow-500 to-orange-500 rounded-2xl p-6 text-white shadow-xl"
           >
             <div className="flex items-center justify-between">
               <div>
                 <p className="text-yellow-100 text-sm font-medium">Đang làm</p>
                 <p className="text-3xl font-bold">{cases.filter(c => c.status === 'in_progress').length}</p>
               </div>
               <Business className="text-4xl text-yellow-200" />
             </div>
           </motion.div>

           <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.3 }}
             whileHover={{ scale: 1.05 }}
             className="bg-gradient-to-br from-purple-500 to-indigo-500 rounded-2xl p-6 text-white shadow-xl"
           >
             <div className="flex items-center justify-between">
               <div>
                 <p className="text-purple-100 text-sm font-medium">Chờ duyệt</p>
                 <p className="text-3xl font-bold">{cases.filter(c => c.status === 'waiting_approval').length}</p>
               </div>
               <Info className="text-4xl text-purple-200" />
             </div>
           </motion.div>

           <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.4 }}
             whileHover={{ scale: 1.05 }}
             className="bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl p-6 text-white shadow-xl"
           >
             <div className="flex items-center justify-between">
               <div>
                 <p className="text-green-100 text-sm font-medium">Hoàn thành</p>
                 <p className="text-3xl font-bold">{cases.filter(c => c.status === 'approved').length}</p>
               </div>
               <Done className="text-4xl text-green-200" />
             </div>
           </motion.div>

           <motion.div
             initial={{ opacity: 0, scale: 0.8 }}
             animate={{ opacity: 1, scale: 1 }}
             transition={{ duration: 0.5, delay: 0.5 }}
             whileHover={{ scale: 1.05 }}
             className="bg-gradient-to-br from-pink-500 to-rose-500 rounded-2xl p-6 text-white shadow-xl"
           >
             <div className="flex items-center justify-between">
               <div>
                 <p className="text-pink-100 text-sm font-medium">Cases có sẵn</p>
                 <p className="text-3xl font-bold">{availableCases.length}</p>
               </div>
               <Add className="text-4xl text-pink-200" />
             </div>
           </motion.div>
         </div>

        {/* Filters and Search */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="bg-white rounded-2xl shadow-xl p-6 mb-8"
        >
                     {/* Tabs and Available Cases Button */}
           <div className="flex flex-wrap gap-2 mb-6">
             {tabLabels.map((label, index) => (
               <button
                 key={label}
                 onClick={() => {
                   setFilterTab(index);
                   setShowAvailableCases(false);
                 }}
                 className={`px-4 py-2 rounded-xl font-medium transition-all duration-300 ${
                   filterTab === index && !showAvailableCases
                     ? 'bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg'
                     : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                 }`}
               >
                 {label}
               </button>
             ))}
             
             <button
               onClick={() => setShowAvailableCases(true)}
               className={`px-4 py-2 rounded-xl font-medium transition-all duration-300 ${
                 showAvailableCases
                   ? 'bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg'
                   : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
               }`}
             >
               Nhận Case
             </button>
           </div>

          
        </motion.div>

                 {/* Cases List */}
         {!showAvailableCases && (
           <motion.div
             initial={{ opacity: 0, y: 30 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.6, delay: 0.8 }}
             className="bg-white rounded-2xl shadow-xl overflow-hidden"
           >
             <div className="p-6 border-b border-gray-100">
               <h2 className="text-2xl font-bold text-gray-800">
                 Danh Sách Cases ({filteredCases.length})
               </h2>
             </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Case</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Hình ảnh SP</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Seller</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Trạng thái</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Ưu tiên</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Deadline</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Chi phí</th>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Thao tác</th>
                </tr>
              </thead>
                             <tbody className="divide-y divide-gray-100">
                 <AnimatePresence>
                   {filteredCases.map((case_, index) => (
                    <motion.tr
                      key={case_.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -20 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      className="hover:bg-gray-50 transition-all duration-300"
                    >
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-3">
                          <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center">
                            <Create className="text-white text-sm" />
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900">
                              {case_.order_id || `Case #${case_.id}`}
                            </p>
                                                         <p className="text-sm text-gray-500">
                               {formatProductName(case_.product_name)}
                             </p>
                            <p className="text-xs text-gray-400">
                              Tạo: {formatDate(case_.created_at)}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        {case_.product_image ? (
                          <div className="flex justify-center">
                            <img
                              src={case_.product_image}
                              alt={formatProductName(case_.product_name)}
                              className="w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm cursor-pointer hover:scale-105 transition-transform duration-200"
                              onClick={() => handleImageClick(case_.product_image, formatProductName(case_.product_name))}
                              onError={(e) => {
                                e.target.src = 'https://via.placeholder.com/64x64?text=No+Image';
                                e.target.className = 'w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm opacity-50';
                              }}
                            />
                          </div>
                        ) : (
                          <div className="flex justify-center">
                            <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center">
                              <Image className="w-6 h-6 text-gray-400" />
                            </div>
                          </div>
                        )}
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                            <Person className="text-gray-500 text-sm" />
                          </div>
                          <span className="text-sm text-gray-700">
                            {case_.seller_email || 'N/A'}
                          </span>
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(case_.status)}`}>
                          {getStatusIcon(case_.status)}
                          <span className="ml-1">{getStatusText(case_.status)}</span>
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getPriorityColor(case_.priority)}`}>
                          {case_.priority || 'medium'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div>
                          <p className="text-sm text-gray-700">
                            {formatDateTime(case_.deadline)}
                          </p>
                          {new Date(case_.deadline) < new Date() && case_.status !== 'approved' && (
                            <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 border border-red-200 mt-1">
                              Quá hạn
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <p className="font-semibold text-gray-900">
                          {formatCurrency(case_.cost_per_design || 0)}
                        </p>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleViewCase(case_)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                            title="Xem chi tiết"
                          >
                            <Visibility className="w-4 h-4" />
                          </button>
                          {case_.status === 'pending' && (
                            <button
                              onClick={() => handleAssignCase(case_.id)}
                              className="p-2 text-green-600 hover:bg-green-50 rounded-lg transition-all duration-300"
                              title="Nhận case"
                            >
                              <PlayArrow className="w-4 h-4" />
                            </button>
                          )}
                          {case_.status === 'in_progress' && (
                            <>
                              <button
                                onClick={() => {
                                  setSelectedCase(case_);
                                  setShowUploadDialog(true);
                                }}
                                className="p-2 text-purple-600 hover:bg-purple-50 rounded-lg transition-all duration-300"
                                title="Upload design"
                              >
                                <Upload className="w-4 h-4" />
                              </button>
                              <button
                                onClick={() => handleUnassignCase(case_.id)}
                                className="p-2 text-orange-600 hover:bg-orange-50 rounded-lg transition-all duration-300"
                                title="Trả lại case"
                              >
                                <Stop className="w-4 h-4" />
                              </button>
                            </>
                          )}
                          {case_.status === 'rejected' && (
                            <button
                              onClick={() => {
                                setSelectedCase(case_);
                                setShowUploadDialog(true);
                              }}
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-all duration-300"
                              title="Upload lại design"
                            >
                              <Upload className="w-4 h-4" />
                            </button>
                          )}
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </AnimatePresence>
              </tbody>
            </table>
          </div>

                                  {filteredCases.length === 0 && (
               <div className="text-center py-12">
                 <Business className="text-gray-300 text-6xl mx-auto mb-4" />
                 <h3 className="text-xl font-semibold text-gray-500 mb-2">
                   Không tìm thấy cases nào
                 </h3>
                 <p className="text-gray-400">
                   Thử thay đổi bộ lọc hoặc nhận case mới
                 </p>
               </div>
             )}
           </motion.div>
         )}

                 {/* Available Cases Section */}
         {showAvailableCases && availableCases.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 1 }}
            className="bg-white rounded-2xl shadow-xl overflow-hidden mt-8"
          >
                         <div className="p-6 border-b border-gray-100">
               <h2 className="text-2xl font-bold text-gray-800">
                 Cases Có Sẵn ({availableCases.length})
               </h2>
               <p className="text-gray-600 mt-2">Các cases chưa được assign cho designer nào - Bấm "Nhận Case" để nhận case</p>
             </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-green-50">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Case</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Hình ảnh SP</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Seller</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Ưu tiên</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Deadline</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Chi phí</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-600">Thao tác</th>
                  </tr>
                </thead>
                                 <tbody className="divide-y divide-gray-100">
                   {availableCases.map((case_, index) => (
                    <motion.tr
                      key={case_.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3, delay: index * 0.1 }}
                      className="hover:bg-green-50 transition-all duration-300"
                    >
                                             <td className="px-6 py-4">
                         <div className="flex items-center space-x-3">
                           <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                             <span className="text-white text-sm font-bold">#{case_.id}</span>
                           </div>
                           <div>
                             <p className="font-semibold text-gray-900">
                               {formatProductName(case_.product_name)}
                             </p>
                             <p className="text-xs text-gray-400">
                               {formatDate(case_.created_at)}
                             </p>
                           </div>
                         </div>
                       </td>
                       <td className="px-6 py-4">
                         {case_.product_image ? (
                           <div className="flex justify-center">
                             <img
                               src={case_.product_image}
                               alt={formatProductName(case_.product_name)}
                               className="w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm cursor-pointer hover:scale-105 transition-transform duration-200"
                               onClick={() => handleImageClick(case_.product_image, formatProductName(case_.product_name))}
                               onError={(e) => {
                                 e.target.src = 'https://via.placeholder.com/64x64?text=No+Image';
                                 e.target.className = 'w-16 h-16 object-cover rounded-lg border border-gray-200 shadow-sm opacity-50';
                               }}
                             />
                           </div>
                         ) : (
                           <div className="flex justify-center">
                             <div className="w-16 h-16 bg-gray-100 rounded-lg border border-gray-200 flex items-center justify-center">
                               <Image className="w-6 h-6 text-gray-400" />
                             </div>
                           </div>
                         )}
                       </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-700">
                          {case_.seller_email || 'N/A'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getPriorityColor(case_.priority)}`}>
                          {case_.priority || 'medium'}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <p className="text-sm text-gray-700">
                          {formatDateTime(case_.deadline)}
                        </p>
                      </td>
                      <td className="px-6 py-4">
                        <p className="font-semibold text-gray-900">
                          {formatCurrency(case_.cost_per_design || 0)}
                        </p>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center space-x-2">
                          <button
                            onClick={() => handleViewAvailableCase(case_)}
                            className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-300"
                            title="Xem chi tiết"
                          >
                            <Visibility className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleAssignCase(case_.id)}
                            className="flex items-center space-x-2 px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-600 text-white rounded-lg hover:shadow-lg transition-all duration-300"
                          >
                            <PlayArrow className="w-3 h-3" />
                            <span className="text-xs font-medium">Nhận</span>
                          </button>
                        </div>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        )}

                 {/* Detail Dialog */}
         {showDetailDialog && selectedCase && (
           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
             <motion.div
               initial={{ opacity: 0, scale: 0.9 }}
               animate={{ opacity: 1, scale: 1 }}
               transition={{ duration: 0.3 }}
               className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
             >
               <div className="p-6 border-b border-gray-200">
                 <div className="flex items-center justify-between">
                   <div className="flex items-center space-x-3">
                     <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full flex items-center justify-center">
                       <Visibility className="text-white text-xl" />
                     </div>
                     <div>
                       <h3 className="text-xl font-bold text-gray-800">
                         Chi Tiết Case #{selectedCase.id}
                       </h3>
                                               <p className="text-sm text-gray-500">
                          {formatProductName(selectedCase.product_name)}
                        </p>
                     </div>
                   </div>
                   <button
                     onClick={() => setShowDetailDialog(false)}
                     className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all duration-300"
                   >
                     <Close className="w-6 h-6" />
                   </button>
                 </div>
               </div>

               <div className="p-6">
                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                   {/* Thông tin cơ bản */}
                   <div className="space-y-4">
                     <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                       Thông Tin Cơ Bản
                     </h4>
                     
                     <div className="space-y-3">
                       <div className="flex justify-between">
                         <span className="text-gray-600">Mã đơn hàng:</span>
                         <span className="font-medium">{selectedCase.order_id || 'N/A'}</span>
                       </div>
                                               <div className="flex justify-between">
                          <span className="text-gray-600">Sản phẩm:</span>
                          <span className="font-medium">{formatProductName(selectedCase.product_name)}</span>
                        </div>
                       {/* Hình ảnh sản phẩm */}
                       {selectedCase.product_image && (
                         <div className="mt-3">
                           <span className="text-gray-600 block mb-2">Hình ảnh sản phẩm:</span>
                           <div className="flex justify-center">
                             <img
                               src={selectedCase.product_image}
                               alt={formatProductName(selectedCase.product_name)}
                               className="w-32 h-32 object-cover rounded-lg border border-gray-200 shadow-sm"
                               onError={(e) => {
                                 e.target.src = 'https://via.placeholder.com/128x128?text=No+Image';
                                 e.target.className = 'w-32 h-32 object-cover rounded-lg border border-gray-200 shadow-sm opacity-50';
                               }}
                             />
                           </div>
                         </div>
                       )}
                       {/* Màu sắc sản phẩm */}
                       {selectedCase.product_color && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">Màu sắc:</span>
                           <span className="font-medium">{selectedCase.product_color}</span>
                         </div>
                       )}
                       {/* SKU sản phẩm */}
                       {selectedCase.product_sku && selectedCase.product_sku !== 'N/A' && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">SKU:</span>
                           <span className="font-medium">{selectedCase.product_sku}</span>
                         </div>
                       )}
                       <div className="flex justify-between">
                         <span className="text-gray-600">Trạng thái:</span>
                         <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(selectedCase.status)}`}>
                           {getStatusIcon(selectedCase.status)}
                           <span className="ml-1">{getStatusText(selectedCase.status)}</span>
                         </span>
                       </div>
                       <div className="flex justify-between">
                         <span className="text-gray-600">Ưu tiên:</span>
                         <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${getPriorityColor(selectedCase.priority)}`}>
                           {selectedCase.priority || 'medium'}
                         </span>
                       </div>
                       <div className="flex justify-between">
                         <span className="text-gray-600">Chi phí:</span>
                         <span className="font-medium text-green-600">{formatCurrency(selectedCase.cost_per_design || 0)}</span>
                       </div>
                     </div>
                   </div>

                   {/* Thông tin thời gian */}
                   <div className="space-y-4">
                     <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                       Thông Tin Thời Gian
                     </h4>
                     
                     <div className="space-y-3">
                       <div className="flex justify-between">
                         <span className="text-gray-600">Tạo lúc:</span>
                         <span className="font-medium">{formatDateTime(selectedCase.created_at)}</span>
                       </div>
                       <div className="flex justify-between">
                         <span className="text-gray-600">Deadline:</span>
                         <span className={`font-medium ${new Date(selectedCase.deadline) < new Date() && selectedCase.status !== 'approved' ? 'text-red-600' : ''}`}>
                           {formatDateTime(selectedCase.deadline)}
                         </span>
                       </div>
                       {selectedCase.received_at && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">Nhận lúc:</span>
                           <span className="font-medium">{formatDateTime(selectedCase.received_at)}</span>
                         </div>
                       )}
                       {selectedCase.completed_at && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">Hoàn thành:</span>
                           <span className="font-medium">{formatDateTime(selectedCase.completed_at)}</span>
                         </div>
                       )}
                       {selectedCase.approved_at && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">Duyệt lúc:</span>
                           <span className="font-medium">{formatDateTime(selectedCase.approved_at)}</span>
                         </div>
                       )}
                       {selectedCase.cancelled_at && (
                         <div className="flex justify-between">
                           <span className="text-gray-600">Hủy lúc:</span>
                           <span className="font-medium">{formatDateTime(selectedCase.cancelled_at)}</span>
                         </div>
                       )}
                     </div>
                   </div>
                 </div>

                 {/* Thông tin liên hệ */}
                 <div className="mt-6 space-y-4">
                   <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                     Thông Tin Liên Hệ
                   </h4>
                   
                   <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                     <div className="bg-gray-50 rounded-xl p-4">
                       <h5 className="font-medium text-gray-800 mb-2">Khách hàng</h5>
                       <div className="space-y-1">
                         <p className="text-sm text-gray-600">Tên: {selectedCase.customer_name || 'N/A'}</p>
                         <p className="text-sm text-gray-600">Email: {selectedCase.customer_email || 'N/A'}</p>
                       </div>
                     </div>
                     <div className="bg-gray-50 rounded-xl p-4">
                       <h5 className="font-medium text-gray-800 mb-2">Seller</h5>
                       <div className="space-y-1">
                         <p className="text-sm text-gray-600">Email: {selectedCase.seller_email || 'N/A'}</p>
                       </div>
                     </div>
                   </div>
                 </div>

                 {/* Ghi chú */}
                 {selectedCase.note && (
                   <div className="mt-6 space-y-4">
                     <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                       Ghi Chú
                     </h4>
                     <div className="bg-gray-50 rounded-xl p-4">
                       <p className="text-gray-700">{selectedCase.note}</p>
                     </div>
                   </div>
                 )}

                 {/* Lý do từ chối */}
                 {selectedCase.rejection_reason && (
                   <div className="mt-6 space-y-4">
                     <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                       Lý Do Từ Chối
                     </h4>
                     <div className="bg-red-50 rounded-xl p-4 border border-red-200">
                       <p className="text-red-700">{selectedCase.rejection_reason}</p>
                     </div>
                   </div>
                 )}

                 {/* Design Files */}
                 {(selectedCase.design_url || selectedCase.design_files) && (
                   <div className="mt-6 space-y-4">
                     <h4 className="text-lg font-semibold text-gray-800 border-b border-gray-200 pb-2">
                       Design Files
                     </h4>
                     <div className="bg-gray-50 rounded-xl p-4">
                       {selectedCase.design_files && selectedCase.design_files.length > 0 ? (
                         <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                           {selectedCase.design_files.map((file, index) => (
                             <div key={index} className="relative">
                               <img
                                 src={file}
                                 alt={`Design ${index + 1}`}
                                 className="w-full h-24 object-cover rounded-lg border border-gray-200"
                                 onError={(e) => {
                                   e.target.src = 'https://via.placeholder.com/150x100?text=Image+Error';
                                 }}
                               />
                               <span className="absolute top-1 right-1 bg-black bg-opacity-50 text-white text-xs px-1 py-0.5 rounded">
                                 {index + 1}
                               </span>
                             </div>
                           ))}
                         </div>
                       ) : selectedCase.design_url ? (
                         <div className="space-y-2">
                           {selectedCase.design_url.split(',').map((url, index) => (
                             <div key={index} className="flex items-center space-x-2">
                               <span className="text-sm text-gray-600">File {index + 1}:</span>
                               <a
                                 href={url.trim()}
                                 target="_blank"
                                 rel="noopener noreferrer"
                                 className="text-blue-600 hover:text-blue-800 text-sm underline"
                               >
                                 {url.trim()}
                               </a>
                             </div>
                           ))}
                         </div>
                       ) : (
                         <p className="text-gray-500">Không có design files</p>
                       )}
                     </div>
                   </div>
                 )}

                 {/* Actions */}
                 <div className="mt-6 flex justify-end space-x-3 pt-4 border-t border-gray-200">
                   <button
                     onClick={() => setShowDetailDialog(false)}
                     className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-xl transition-all duration-300"
                   >
                     Đóng
                   </button>
                   {selectedCase.status === 'pending' && (
                     <button
                       onClick={() => {
                         setShowDetailDialog(false);
                         handleAssignCase(selectedCase.id);
                       }}
                       className="px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-medium transition-all duration-300 shadow-lg"
                     >
                       Nhận Case
                     </button>
                   )}
                   {selectedCase.status === 'in_progress' && (
                     <button
                       onClick={() => {
                         setShowDetailDialog(false);
                         setShowUploadDialog(true);
                       }}
                       className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white rounded-xl font-medium transition-all duration-300 shadow-lg"
                     >
                       Upload Design
                     </button>
                   )}
                   {selectedCase.status === 'rejected' && (
                     <button
                       onClick={() => {
                         setShowDetailDialog(false);
                         setShowUploadDialog(true);
                       }}
                       className="px-6 py-2 bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white rounded-xl font-medium transition-all duration-300 shadow-lg"
                     >
                       Upload Lại Design
                     </button>
                   )}
                 </div>
               </div>
             </motion.div>
           </div>
         )}

         {/* Upload Dialog */}
         {showUploadDialog && selectedCase && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl shadow-2xl max-w-md w-full"
            >
              <div className="p-6">
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full flex items-center justify-center">
                    <Upload className="text-white text-xl" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">
                      Upload Design
                    </h3>
                    <p className="text-sm text-gray-500">
                      Case #{selectedCase.id}
                    </p>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="bg-gray-50 rounded-xl p-4">
                    <p className="text-sm text-gray-600 mb-2">
                      <span className="font-semibold">Sản phẩm:</span> {formatProductName(selectedCase.product_name)}
                    </p>
                    <p className="text-sm text-gray-600">
                      <span className="font-semibold">Chi phí:</span> {formatCurrency(selectedCase.cost_per_design || 0)}
                    </p>
                  </div>

                  {/* Upload Tabs */}
                  <div className="flex space-x-1 bg-gray-100 rounded-xl p-1">
                    <button
                      onClick={() => setUploadTab('url')}
                      className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
                        uploadTab === 'url' 
                          ? 'bg-white text-purple-600 shadow-sm' 
                          : 'text-gray-600 hover:text-gray-800'
                      }`}
                    >
                      <Link className="w-4 h-4 mr-2" />
                      Upload URL
                    </button>
                    <button
                      onClick={() => setUploadTab('file')}
                      disabled={true}
                      className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all duration-300 ${
                        uploadTab === 'file' 
                          ? 'bg-white text-purple-600 shadow-sm' 
                          : 'text-gray-400 cursor-not-allowed opacity-50'
                      }`}
                      title="Tính năng đang phát triển"
                    >
                      <CloudUpload className="w-4 h-4 mr-2" />
                      Upload File
                    </button>
                  </div>

                  {/* URL Upload Tab */}
                  {uploadTab === 'url' && (
                    <div className="space-y-4">
                      <div className="space-y-3">
                        {uploadUrls.map((url, index) => (
                          <div key={index} className="flex space-x-2">
                            <input
                              type="url"
                              value={url}
                              onChange={(e) => handleUrlChange(index, e.target.value)}
                              placeholder="Nhập URL design (VD: https://example.com/design.jpg)"
                              className="flex-1 px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-300"
                            />
                            {uploadUrls.length > 1 && (
                              <button
                                onClick={() => removeUrlField(index)}
                                className="px-3 py-3 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-xl transition-all duration-300"
                              >
                                <Close className="w-4 h-4" />
                              </button>
                            )}
                          </div>
                        ))}
                      </div>
                      
                      {uploadUrls.length < 5 && (
                        <button
                          onClick={addUrlField}
                          className="w-full py-3 px-4 border-2 border-dashed border-gray-300 rounded-xl text-gray-600 hover:border-purple-400 hover:text-purple-600 transition-all duration-300 flex items-center justify-center"
                        >
                          <Add className="w-4 h-4 mr-2" />
                          Thêm URL khác
                        </button>
                      )}
                    </div>
                  )}

                  {/* File Upload Tab (Disabled) */}
                  {uploadTab === 'file' && (
                    <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center opacity-50">
                      <input
                        type="file"
                        onChange={handleFileUpload}
                        accept="image/*,.pdf,.zip,.rar"
                        multiple
                        className="hidden"
                        id="file-upload"
                        disabled
                      />
                      <label htmlFor="file-upload" className="cursor-not-allowed">
                        <CloudUpload className="text-gray-400 text-4xl mx-auto mb-4" />
                        <p className="text-gray-600 font-medium mb-2">
                          Upload File (Đang phát triển)
                        </p>
                        <p className="text-gray-500 text-sm">
                          Tính năng này sẽ có sẵn sau khi backend hoàn thiện
                        </p>
                      </label>
                    </div>
                  )}

                  {/* Progress Bar */}
                  {uploadProgress > 0 && (
                    <div className="space-y-2">
                      <div className="flex justify-between text-sm">
                        <span>Uploading...</span>
                        <span>{uploadProgress}%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-gradient-to-r from-purple-500 to-pink-600 h-2 rounded-full transition-all duration-300"
                          style={{ width: `${uploadProgress}%` }}
                        ></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
                                 <button
                   onClick={() => {
                     setShowUploadDialog(false);
                     setUploadingFiles([]);
                     setUploadUrls(['']);
                     setUploadProgress(0);
                     setUploadTab('url');
                   }}
                   className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-xl transition-all duration-300"
                 >
                   Hủy
                 </button>
                 <button
                   onClick={() => {
                     if (uploadTab === 'url') {
                       const validUrls = uploadUrls.filter(url => url.trim() !== '');
                       if (validUrls.length > 0) {
                         handleUploadUrls(selectedCase.id, uploadUrls);
                       } else {
                         toast.error('Vui lòng nhập ít nhất 1 URL!');
                       }
                     } else {
                       if (uploadingFiles.length > 0) {
                         handleUploadDesign(selectedCase.id, uploadingFiles);
                       } else {
                         toast.error('Vui lòng chọn ít nhất 1 file!');
                       }
                     }
                   }}
                   disabled={
                     (uploadTab === 'url' && uploadUrls.every(url => url.trim() === '')) ||
                     (uploadTab === 'file' && uploadingFiles.length === 0) ||
                     uploadProgress > 0
                   }
                   className="px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white rounded-xl font-medium transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                 >
                   Upload {
                     uploadTab === 'url' 
                       ? `(${uploadUrls.filter(url => url.trim() !== '').length} URLs)` 
                       : `(${uploadingFiles.length} files)`
                   }
                 </button>
              </div>
            </motion.div>
          </div>
        )}

        {/* Image Popup */}
        {showImagePopup && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-[9999]" onWheel={handleImageWheel}>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.3 }}
              className="relative max-w-4xl max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden"
            >
              <div className="absolute top-4 right-4 z-10 flex items-center space-x-2">
                <button
                  onClick={() => setImageScale(Math.max(0.5, imageScale - 0.2))}
                  className="p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-75 transition-all duration-300"
                  title="Thu nhỏ"
                >
                  <Remove className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setImageScale(1)}
                  className="px-3 py-2 bg-black bg-opacity-50 text-white rounded-lg hover:bg-opacity-75 transition-all duration-300 text-sm font-medium"
                  title="Khôi phục kích thước"
                >
                  {Math.round(imageScale * 100)}%
                </button>
                <button
                  onClick={() => setImageScale(Math.min(3, imageScale + 0.2))}
                  className="p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-75 transition-all duration-300"
                  title="Phóng to"
                >
                  <Add className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setShowImagePopup(false)}
                  className="p-2 bg-black bg-opacity-50 text-white rounded-full hover:bg-opacity-75 transition-all duration-300"
                  title="Đóng"
                >
                  <Close className="w-6 h-6" />
                </button>
              </div>
              <div className="p-4 text-center overflow-auto">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">{selectedImageAlt}</h3>
                <div className="flex justify-center">
                  <img
                    src={selectedImage}
                    alt={selectedImageAlt}
                    className="object-contain rounded-lg transition-transform duration-200"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '70vh',
                      transform: `scale(${imageScale})`,
                      cursor: imageScale > 1 ? 'grab' : 'default'
                    }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x300?text=Image+Not+Found';
                    }}
                  />
                </div>
                <div className="mt-4 text-sm text-gray-500">
                  <p>Lăn chuột để phóng to/thu nhỏ • Sử dụng nút +/- để điều chỉnh chính xác</p>
                </div>
              </div>
            </motion.div>
          </div>
        )}

        {/* Available Case Detail Dialog */}
        {showAvailableCaseDetail && selectedAvailableCase && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            >
              <div className="p-6 border-b border-gray-200">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                      <Business className="text-white text-xl" />
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-800">
                        Chi Tiết Case Có Sẵn #{selectedAvailableCase.id}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {formatProductName(selectedAvailableCase.product_name)}
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowAvailableCaseDetail(false)}
                    className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-all duration-300"
                  >
                    <Close className="w-6 h-6" />
                  </button>
                </div>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Thông tin cơ bản */}
                  <div className="space-y-4">
                    <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl border border-green-200">
                      <h4 className="font-semibold text-green-800 mb-3 flex items-center">
                        <Info className="w-5 h-5 mr-2" />
                        Thông Tin Cơ Bản
                      </h4>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-gray-600">ID Case:</span>
                          <span className="font-medium text-gray-800">#{selectedAvailableCase.id}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Sản phẩm:</span>
                          <span className="font-medium text-gray-800">{formatProductName(selectedAvailableCase.product_name)}</span>
                        </div>
                        {selectedAvailableCase.product_sku && selectedAvailableCase.product_sku !== 'N/A' && (
                          <div className="flex justify-between">
                            <span className="text-gray-600">SKU:</span>
                            <span className="font-medium text-gray-800">{selectedAvailableCase.product_sku}</span>
                          </div>
                        )}
                        {selectedAvailableCase.product_color && (
                          <div className="flex justify-between">
                            <span className="text-gray-600">Màu sắc:</span>
                            <span className="font-medium text-gray-800">{selectedAvailableCase.product_color}</span>
                          </div>
                        )}
                        <div className="flex justify-between">
                          <span className="text-gray-600">Seller:</span>
                          <span className="font-medium text-gray-800">{selectedAvailableCase.seller_email || 'N/A'}</span>
                        </div>
                      </div>
                    </div>

                    {/* Hình ảnh sản phẩm */}
                    {selectedAvailableCase.product_image && (
                      <div className="bg-white p-4 rounded-xl border border-gray-200">
                        <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                          <Image className="w-5 h-5 mr-2" />
                          Hình Ảnh Sản Phẩm
                        </h4>
                        <div className="flex justify-center">
                          <img
                            src={selectedAvailableCase.product_image}
                            alt={formatProductName(selectedAvailableCase.product_name)}
                            className="w-48 h-48 object-cover rounded-lg border border-gray-200 shadow-sm cursor-pointer hover:scale-105 transition-transform duration-200"
                            onClick={() => handleImageClick(selectedAvailableCase.product_image, formatProductName(selectedAvailableCase.product_name))}
                            onError={(e) => {
                              e.target.src = 'https://via.placeholder.com/192x192?text=No+Image';
                              e.target.className = 'w-48 h-48 object-cover rounded-lg border border-gray-200 shadow-sm opacity-50';
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Thông tin chi tiết */}
                  <div className="space-y-4">
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-xl border border-blue-200">
                      <h4 className="font-semibold text-blue-800 mb-3 flex items-center">
                        <Assessment className="w-5 h-5 mr-2" />
                        Thông Tin Chi Tiết
                      </h4>
                      <div className="space-y-2">
                        <div className="flex justify-between">
                          <span className="text-gray-600">Ưu tiên:</span>
                          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${getPriorityColor(selectedAvailableCase.priority)}`}>
                            {selectedAvailableCase.priority || 'medium'}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Deadline:</span>
                          <span className="font-medium text-gray-800">{formatDateTime(selectedAvailableCase.deadline)}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Chi phí:</span>
                          <span className="font-semibold text-green-600">{formatCurrency(selectedAvailableCase.cost_per_design || 0)}</span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-600">Ngày tạo:</span>
                          <span className="font-medium text-gray-800">{formatDate(selectedAvailableCase.created_at)}</span>
                        </div>
                      </div>
                    </div>

                    {/* Mô tả */}
                    {selectedAvailableCase.description && (
                      <div className="bg-white p-4 rounded-xl border border-gray-200">
                        <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                          <Description className="w-5 h-5 mr-2" />
                          Mô Tả
                        </h4>
                        <p className="text-gray-700 text-sm leading-relaxed">
                          {selectedAvailableCase.description}
                        </p>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-6 flex justify-end space-x-3">
                  <button
                    onClick={() => setShowAvailableCaseDetail(false)}
                    className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded-xl transition-all duration-300"
                  >
                    Đóng
                  </button>
                  <button
                    onClick={() => {
                      handleAssignCase(selectedAvailableCase.id);
                      setShowAvailableCaseDetail(false);
                    }}
                    className="flex items-center space-x-2 px-6 py-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white rounded-xl font-medium transition-all duration-300 shadow-lg"
                  >
                    <PlayArrow className="w-4 h-4" />
                    <span>Nhận Case</span>
                  </button>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default DesignerCaseList; 